/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import merge from 'lodash.merge';
import { Periods } from 'cio/utils/metrics/common';
import moment from 'moment-timezone';
import type { Options, SeriesOptionsType } from 'highcharts';

interface HcLineChartArgs {
  series: SeriesOptionsType[];
  chartOptions: Options;
  period?: Periods;
  xAxisDateTimePeriod?: Periods;
  loading?: boolean;
  loadingNotice?: string;
  timeRange?: { start?: moment.Moment; end?: moment.Moment } | null;
  timezone?: string;
  showUntrackedChangeAnnotation?: boolean;
  enableExport?: boolean;
}

export default class HcLineChart extends Component<HcLineChartArgs> {
  get chartOptions(): Options {
    return merge(
      {
        xAxis: {
          type: 'datetime',
        },

        series: this.args.series,
      },
      this.args.chartOptions,
    );
  }
}
